const column = {
  path: 'column/',
  name: 'Column',
  redirect: { name: 'ColumnOverview' },
  children: [
    {
      path: 'overview',
      name: 'ColumnOverview',
      component: () => import('@/views/column'),
      meta: {
        title: 'column_overview',
      },
    },
    {
      path: ':id',
      name: 'ColumnDetail',
      component: () => import('@/views/column/Detail'),
      meta: {
        title: 'column_detail',
      },
    },
  ],
};

export default column;
